import StagesPageContainer from './stages-page-container';

class StagesBasePageContainer extends StagesPageContainer {
    getSeasonId(){
        return this.props.params.seasonId;
    }

}
export default  StagesBasePageContainer;



// WEBPACK FOOTER //
// ./src/js/containers/pages/season-stages-page-container.js